import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/StoreList/StoreList.jsx");
